<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <h4 class="modal-card-title">
        Add New Delivery
      </h4>
      <p class="is-size-5 has-text-weight-normal is-italic has-text-right mr-0 required-label has-text-dark">*required</p>

    </header>
    <section class="modal-card-body is-size-4">
        <div class="column p-0">
            <label class="label is-italic  has-text-weight-semibold">Shipping Order</label>
            <div class="field-body">
                <span class="is-regular">{{ shipping.name }}</span>
            </div>
            <div class="columns  mt-3">
                <div class="column">
                    <h4 class="is-size-3 is-italic">
                        Source Details
                    </h4>
                    <label class="label is-italic mt-4 is-italic  has-text-weight-semibold">Source Project</label>
                    <div class="field-body">
                        <span class="is-regular">{{ $_.get(shipping, 'delivery.currentProject.name', '') }}</span>
                    </div>
                    <label class="label is-italic mt-4 is-italic  has-text-weight-semibold">Source Location</label>
                    <div class="field-body">
                        <span class="is-regular">{{ $_.get(shipping, 'delivery.currentLocation.name', '') }}</span>
                    </div>
                    <label class="label is-italic mt-4 is-italic  has-text-weight-semibold">Order Owner/Sender</label>
                    <div class="field-body">
                        <span class="is-regular">{{ $_.get(shipping, 'delivery.owner.name', '') }}</span>
                    </div>
                </div>
                <div class="column">
                    <h4 class="is-size-3 is-italic">
                        Destination Details
                    </h4>
                    <label class="label is-italic mt-4 is-italic  has-text-weight-semibold">Destination Project</label>
                    <div class="field-body">
                        <span class="is-regular">{{ $_.get(shipping, 'delivery.deliveryProject.name', '') }}</span>
                    </div>
                    <label class="label is-italic mt-4 is-italic  has-text-weight-semibold">Destination Location</label>
                    <div class="field-body">
                        <span class="is-regular">{{ $_.get(shipping, 'delivery.deliveryLocation.name', '') }}</span>
                    </div>
                    <label class="label is-italic mt-4 is-italic  has-text-weight-semibold">Recipient</label>
                    <div class="field-body">
                        <span class="is-regular">{{ $_.get(shipping, 'delivery.recipient.name', '') }}</span>
                    </div>  
                </div>
            </div>
            <div class="field">
                <h4 class="is-size-3 is-italic  has-text-weight-semibold">
                    Delivery Details
                </h4>
                 <div class="column pt-0">
          <div class="columns">
            <div class="column">
              <div class="field">
                <div class="field-label">
                  <label class="label is-size-3 is-italic  has-text-weight-semibold"> Delivery Name* </label>
                </div>
                <div class="field-body">
                  <div class="control">
                      <input class="input" v-model.trim="delivery.name"
                        placeholder="Enter name (3 or more characters)">
                    </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns">
                <div class="column">
                  <field-date
                    label="Ship By"
                    :isEdit="true"
                    :item="delivery"
                    :inputProps="{kind: 'deliveryStart', max: 'deliverBy',  pos: 'top-right'}"
                    @set-date="(val)=> delivery.deliveryStart = val"
                    :isEmptyShip="true"
                    >
                  </field-date>
                </div>
                <div class="column">
                  <field-date
                    label="Deliver By*"
                    :isEdit="true"
                    :item="delivery"
                    :inputProps="{min: 'deliveryStart', kind: 'deliverBy', pos: 'top-right'}"
                    @set-date="(val)=> delivery.deliverBy = val"
                    :isEmptyShip="true"
                    >
                  </field-date>
                </div>
              </div>            
            </div>           
          </div>
        </div>
            </div>
        </div>
       
    </section>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <button class="button is-outlined" @click="cancel()">Cancel</button>
      <button class="button has-background-black-bis"
              :disabled="disabled"
              @click="createDelivery()">Add Delivery </button>
      </footer>
  </div>
  <o-loading
      :full-page="false"
      :active="isLoading"
      :can-cancel="true"
    ></o-loading>
</template>
<script>
import {
  reactive, toRefs, computed
} from 'vue';
 import Shipping from '@/models/Shipping';
 import { useRouter } from 'vue-router';
 import { isEmpty } from 'lodash';

export default {
  props: {
    shipping: Object,
  },
  setup(props, { emit }) {
    const state = reactive({
      delivery: {
        name: '',
        deliverBy: {},
        deliveryStart: {},
        parentShipmentId: props.shipping.id
      },
      isLoading: false,
    });
    const router = useRouter();

    const disabled = computed(() => {
      return !(state.delivery.name && state.delivery.name.length >=3  && !_.isEmpty(_.get(state.delivery, 'deliverBy', '')));
    })
 
    const cancel = (params) => {
      emit('close', params);
    };

    const createDelivery = async() => {
      let newShipment = {};
       try {
        state.isLoading = true;
        if(props.shipping.shipType === 's-m') {
          newShipment = await Shipping.breakShipmentIntoPartials({
            shippingLabelId: props.shipping._id,
            isNewDelivery: true
          })
        }
        if(!_.isEmpty(newShipment)) {
          state.delivery.parentShipmentId = newShipment._id
        }
        await Shipping.addEmptyDelivery(state.delivery);
       } catch (error) {
        console.log(error);
        return;
       }finally {
        state.isLoading = false;
       }
       cancel(!isEmpty(newShipment) ?
       {
        projectId: props.shipping.delivery.currentProject._id,
        id: state.delivery.parentShipmentId
       }
       :
       {}
      );
    }

    return {
      ...toRefs(state),
      cancel,
      disabled,
      createDelivery
    };
  },
};
</script>

<style scoped>
  .modal-card-body {
    overflow: visible;
  }
  .modal-card-head {
    background-color: #fff !important;
    border-bottom: none !important;
  }
  .modal-card-foot {
    border-top: 1px solid #84888c;
     background-color: #fff !important;
  }
</style>
